import * as _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";

/**
 * Toggles paste mode on/off, allowing the user to place copied lights on the map.
 *
 * @yields Selects paste state and dispatches mode toggle actions.
 */
function* togglePasteMode() {
    try {
        const { pasteMode, selectedLights, clipboard } = yield select(
            (state) => ({
                pasteMode: state.map.general.pasteMode,
                selectedLights: _.filter(
                    state.map.values.mode.present.lights,
                    (light) => light.selected,
                ),
                clipboard: state.map.general.clipboard,
            }),
        );
        let information = "";
        let activated = false;
        if (clipboard.length > 0 && !pasteMode.activated) {
            yield put(actions.map.general.deselectAllLights());
            information = `Tap where you’d like to place the ${clipboard.length} copied lights. Any lights that overlap existing lights will not be pasted. Copied lights are pasted starting with the top left to bottom right of copied array.`;
            activated = true;
        } else {
            yield put(
                actions.map.general.selectLights(
                    pasteMode.selectedLights,
                    "multiple",
                ),
            );
        }
        yield put(
            actions.map.general.setPasteMode(
                activated,
                activated ? selectedLights : [],
            ),
        );
        yield put(actions.window.setInformation(information));
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("err on toggle paste mode:", err);
    }
}

export default togglePasteMode;
